"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImportResumePopup = ImportResumePopup;
var _AddModeratorTwoTone = _interopRequireDefault(require("@mui/icons-material/AddModeratorTwoTone"));
var _GppBadTwoTone = _interopRequireDefault(require("@mui/icons-material/GppBadTwoTone"));
var _GppGoodTwoTone = _interopRequireDefault(require("@mui/icons-material/GppGoodTwoTone"));
var _GppMaybeTwoTone = _interopRequireDefault(require("@mui/icons-material/GppMaybeTwoTone"));
var _HealthAndSafetyTwoTone = _interopRequireDefault(require("@mui/icons-material/HealthAndSafetyTwoTone"));
var _InsertDriveFileTwoTone = _interopRequireDefault(require("@mui/icons-material/InsertDriveFileTwoTone"));
var _RemoveModeratorTwoTone = _interopRequireDefault(require("@mui/icons-material/RemoveModeratorTwoTone"));
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ImportResumePopup(_ref) {
  var summary = _ref.summary,
    onClose = _ref.onClose,
    _ref$elements = _ref.elements,
    elements = _ref$elements === void 0 ? ['read', 'divider', 'created', 'active', 'inactive', 'divider', 'failed', 'duplicated', 'exceeded'] : _ref$elements;
  var values = summary;
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    variant: summary.error_report_url ? 'error' : undefined,
    title: (0, _core.translate)('importable.result.title'),
    onClose: onClose,
    button: summary.error_report_url ? {
      text: (0, _core.translate)('importable.result.error_report'),
      href: summary.error_report_url
    } : undefined
  }, /*#__PURE__*/_react["default"].createElement(_material.List, {
    dense: true,
    disablePadding: true
  }, elements.map(function (status, i) {
    return /*#__PURE__*/_react["default"].createElement(StatusListItem, {
      key: "".concat(status, "-").concat(i),
      status: status,
      value: values[status]
    });
  })));
}
function StatusListItem(_ref2) {
  var status = _ref2.status,
    value = _ref2.value,
    _ref2$fontSize = _ref2.fontSize,
    fontSize = _ref2$fontSize === void 0 ? 'medium' : _ref2$fontSize;
  var getIcon = function getIcon() {
    switch (status) {
      case 'read':
        return /*#__PURE__*/_react["default"].createElement(_InsertDriveFileTwoTone["default"], {
          color: "primary",
          fontSize: fontSize
        });
      case 'created':
        return /*#__PURE__*/_react["default"].createElement(_AddModeratorTwoTone["default"], {
          color: "success",
          fontSize: fontSize
        });
      case 'active':
        return /*#__PURE__*/_react["default"].createElement(_GppGoodTwoTone["default"], {
          color: "info",
          fontSize: fontSize
        });
      case 'inactive':
        return /*#__PURE__*/_react["default"].createElement(_RemoveModeratorTwoTone["default"], {
          fontSize: fontSize
        });
      case 'failed':
        return /*#__PURE__*/_react["default"].createElement(_GppBadTwoTone["default"], {
          color: "error",
          fontSize: fontSize
        });
      case 'duplicated':
        return /*#__PURE__*/_react["default"].createElement(_HealthAndSafetyTwoTone["default"], {
          color: "secondary",
          fontSize: fontSize
        });
      case 'exceeded':
      default:
        return /*#__PURE__*/_react["default"].createElement(_GppMaybeTwoTone["default"], {
          color: "warning",
          fontSize: fontSize
        });
    }
  };
  if (status === 'divider') {
    return /*#__PURE__*/_react["default"].createElement(_material.Divider, null);
  }
  return /*#__PURE__*/_react["default"].createElement(_material.ListItem, {
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, getIcon()), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
    primary: (0, _core.translate)("importable.result.".concat(status))
  }), /*#__PURE__*/_react["default"].createElement(_material.ListItemSecondaryAction, {
    sx: {
      width: 50
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "h6",
    align: "center"
  }, value)));
}